import React from 'react';
import { Collapse } from 'antd';
import 'antd/dist/reset.css';

const { Panel } = Collapse;

export default function PAQ() {
    const faqData = [
        {
          question: "Warranty",
          answer: "We stand by the quality of our products. All of our custom-made products come with a warranty to ensure your satisfaction. If you encounter any issues with your product due to manufacturing defects, please contact us, and we will address the problem promptly."
        },
        {
          question: "What is your return policy?",
          answer: "As our products are custom-made, we are unable to offer refunds after installation. Similarly, deposit payments cannot be refunded once materials have been ordered and cut. However, your satisfaction is our priority. If the product does not meet your expectations, we will work with you to make it right."
        },
        {
          question: "What payment do you offer?",
          answer: "Cash or Bank Transfer."
        },
        {
          question: "DIY Measurement and Installation?",
          answer: "We provide an online tool that allows you to easily create a new order. Simply measure your space, input the measurements into our website, and complete your payment. We’ll take care of the rest and supply the custom shades directly to you. If you need any assistance, feel free to contact us for guidance."
        },
        {
          question: "Do you provide installation services for your products?",
          answer: "Yes, we offer professional installation services for all our products, including window blinds, outdoor awnings, roller shutters, and plantation shutters. Our experienced team ensures a perfect fit and hassle-free installation process."
        },
        {
          question: "What is the turnaround time for your product?",
          answer: "Our products are made to order, and it typically takes approximately 2-3 weeks from the deposit date to delivery to complete the assembly. However, simpler orders may take less time. Please contact us for more details."
        },
        
      ];
    
      return (
        <div className="w-full mx-auto  hedvig-letters-sans-regular">
          <Collapse accordion className='overflow-hidden rounded-md'>
            {faqData.map((faq, index) => (
              <Panel header={faq.question} key={index} className="text-xl text-black bg-white">
                <p className="text-gray-500">{faq.answer}</p>
              </Panel>
            ))}
          </Collapse>
        </div>
      );
    };
    
